// extracted by mini-css-extract-plugin
export var bigNumbersContainer = "index-module--bigNumbersContainer--KoV3t";
export var bigNumbersInnerWrapper = "index-module--bigNumbersInnerWrapper--Lex0j";
export var bigNumbersWrapper = "index-module--bigNumbersWrapper--g+xSD";
export var block = "index-module--block--KyNsR";
export var subtitle = "index-module--subtitle--PM-uy";
export var title = "index-module--title--JuWiV";